module.exports = __webpack_public_path__ + "static/media/groepsbewerk.12175e4f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/groepsbewerk.svg
// module id = 781
// module chunks = 0